/* Asesorías · Max Rodríguez — animación.
   Regla: el contenido existe y se ve sin esto. Solo animamos transform, opacity y clip-path. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ka]');
  if (!root) return;
  var html = document.documentElement;

  /* ---------- Barra fija en celular (no depende de GSAP) ---------- */
  var dock = root.querySelector('[data-ka-dock]');
  var hero = root.querySelector('.ka-hero');
  var end = root.querySelector('.ka-end');
  if (dock && hero && 'IntersectionObserver' in window) {
    var heroVis = true, endVis = false, showVis = false;
    var sync = function () { var on = !heroVis && !endVis && !showVis; dock.classList.toggle('is-on', on); html.classList.toggle('ka-dock-on', on && window.matchMedia('(max-width: 989px)').matches); };
    new IntersectionObserver(function (e) { heroVis = e[0].isIntersecting; sync(); }).observe(hero);
    if (end) new IntersectionObserver(function (e) { endVis = e[0].isIntersecting; sync(); }).observe(end);
    var showOn = 0;
    Array.prototype.forEach.call(root.querySelectorAll('[data-ka-show]'), function (sec) {
      var was = false;
      new IntersectionObserver(function (e) { var now = e[0].isIntersecting; if (now !== was) { showOn += now ? 1 : -1; was = now; } showVis = showOn > 0; sync(); }).observe(sec);
    });
  }

  var gsap = window.gsap, ST = window.ScrollTrigger, Split = window.SplitText;
  if (!gsap || !ST || !html.classList.contains('ka-js')) { html.classList.remove('ka-js'); return; }

  try {
    gsap.registerPlugin(ST);
    if (Split) gsap.registerPlugin(Split);
    window.__kaReady = true;
    root.classList.add('is-gsap');

    var q = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
    var headerH = function () { var h = document.querySelector('kong-header'); return h ? h.offsetHeight : 0; };
    var EXPO = 'expo.out', P4 = 'power4.out';

    /* ---------- 1. Portada: orquestada ---------- */
    gsap.set(q(".ka-hero .ka-line__in"), { yPercent: 105, y: 0 });
    var tl = gsap.timeline({ defaults: { ease: EXPO } });
    tl.to(q(".ka-hero .ka-line__in"), { yPercent: 0, duration: 1.3, stagger: .12 }, .1)
      .to(q(".ka-hero [data-ka-arch]"), { clipPath: "inset(0% 0 0 0 round 999px 999px 26px 26px)", duration: 1.5, ease: "power4.inOut" }, 0)
      .fromTo(q(".ka-hero [data-ka-arch] img"), { scale: 1.18 }, { scale: 1, duration: 1.9 }, 0)
      .to(q(".ka-hero [data-ka-fade]"), { opacity: 1, y: 0, duration: 1.1, stagger: .09, ease: P4 }, .45)
      .to(q(".ka-hero .ka-hero__badge, .ka-hero .ka-sun"), { opacity: 1, duration: .9, stagger: .1 }, 1.0);

    /* ---------- Títulos: líneas con máscara ---------- */
    q('[data-ka-split]').forEach(function (el) {
      gsap.set(el, { opacity: 1 });
      if (!Split) { gsap.from(el, { y: 30, opacity: 0, duration: 1, ease: P4, scrollTrigger: { trigger: el, start: 'top 88%', once: true } }); return; }
      Split.create(el, {
        type: 'lines', mask: 'lines', linesClass: 'ka-sl', autoSplit: true,
        onSplit: function (self) {
          return gsap.from(self.lines, {
            yPercent: 110, duration: 1.15, stagger: .09, ease: EXPO,
            scrollTrigger: { trigger: el, start: 'top 88%', once: true }
          });
        }
      });
    });

    /* ---------- Bloques que aparecen ---------- */
    ST.batch(q('[data-ka-fade]').filter(function (el) { return !el.closest('.ka-hero'); }), {
      start: 'top 92%', once: true,
      onEnter: function (b) { gsap.to(b, { opacity: 1, y: 0, duration: 1.05, stagger: .08, ease: P4, overwrite: true }); }
    });
    ST.batch(q('[data-ka-card]'), {
      start: 'top 90%', once: true,
      onEnter: function (b) { gsap.to(b, { opacity: 1, y: 0, duration: 1.2, stagger: .12, ease: EXPO, overwrite: 'auto' }); }
    });
    q('[data-ka-clip]').forEach(function (el) {
      gsap.to(el, { clipPath: 'inset(0 0 0% 0 round 26px)', duration: 1.4, ease: 'power4.inOut', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
      var img = el.querySelector('img');
      if (img) gsap.fromTo(img, { scale: 1.15 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    /* ---------- 2. Marquee ligado al scroll ---------- */
    var rows = q('[data-ka-row]').map(function (row) {
      var dir = Number(row.getAttribute('data-ka-row')) || 1;
      var dur = dir > 0 ? 46 : 54;
      return dir > 0
        ? gsap.fromTo(row, { xPercent: 0 }, { xPercent: -50, duration: dur, ease: 'none', repeat: -1 })
        : gsap.fromTo(row, { xPercent: -50 }, { xPercent: 0, duration: dur, ease: 'none', repeat: -1 });
    });
    var marq = root.querySelector('[data-ka-marquee]');
    var calm = gsap.delayedCall(.3, function () { gsap.to(rows, { timeScale: 1, duration: 1.2, ease: "power2.out", overwrite: true }); }).pause();
    if (marq && rows.length) {
      ST.create({
        trigger: marq, start: 'top bottom', end: 'bottom top',
        onToggle: function (self) { rows.forEach(function (r) { self.isActive ? r.play() : r.pause(); }); },
        onUpdate: function (self) {
          var ts = gsap.utils.clamp(1, 6, 1 + Math.abs(self.getVelocity()) / 260);
          gsap.to(rows, { timeScale: ts, duration: .2, overwrite: true });
          calm.restart(true);
        }
      });
    }

    /* ---------- Hojas: parallax suave ---------- */
    q('.ka-hero__leaves, .ka-plans__leaves, .ka-end__leaves').forEach(function (layer, i) {
      gsap.to(layer, { yPercent: i % 2 ? -10 : 12, ease: 'none', scrollTrigger: { trigger: layer.parentNode, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    /* ---------- 5. Cómo funciona: paso activo ---------- */
    var steps = q('[data-ka-step]');
    var num = root.querySelector('[data-ka-stepnum]');
    var setStep = function (i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (num) num.textContent = ('0' + (i + 1)).slice(-2);
    };
    steps.forEach(function (st, i) {
      ST.create({
        trigger: st, start: 'top 62%', end: 'bottom 62%',
        onToggle: function (self) { if (self.isActive) setStep(i); }
      });
    });

    var mm = gsap.matchMedia();
    var pinned = q('[data-ka-show], [data-ka-results]');
    var prio = function (el) { return pinned.length - pinned.indexOf(el); };

    /* ---------- v3 · Selector fijo de coach ---------- */
    var cnav = root.querySelector('[data-ka-cnav]');
    if (cnav) {
      var links = q('[data-ka-cnav-to]', cnav);
      var setCoach = function (who) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-ka-cnav-to') === who); }); };
      var chs = q('[data-ka-ch]');
      var activeN = 0;
      chs.forEach(function (ch) {
        ST.create({
          trigger: ch, start: 'top 55%', end: 'bottom 55%',
          onToggle: function (self) {
            activeN += self.isActive ? 1 : -1;
            if (self.isActive) setCoach(ch.getAttribute('data-ka-ch'));
            cnav.classList.toggle('is-on', activeN > 0);
          }
        });
      });
    }

    /* =========================================================
       v2 · Transformación destacada: escenario fijo + cortina
       ========================================================= */
    ST.config({ ignoreMobileResize: true });
    q('[data-ka-show]').forEach(function (show) {
      var items = q('[data-ka-show-item]', show);
      var stage = show.querySelector('[data-ka-stage]');
      var wA = show.querySelector('[data-ka-word-a]');
      var wD = show.querySelector('[data-ka-word-d]');
      var nEl = show.querySelector('[data-ka-show-n]');
      var dots = q('.ka-show__dots i', show);
      if (items.length && stage) {
        show.classList.add('is-live');
        var setIdx = function (i) {
          if (nEl) nEl.textContent = ('0' + (i + 1)).slice(-2);
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        };
        var stw = function () { return stage.clientWidth; };
        var starts = [];
        var cur = -1;
        var st = gsap.timeline({ defaults: { ease: 'none' }, onUpdate: function () {
          var t = st.time(), k = 0;
          for (var j = 0; j < starts.length; j++) if (t >= starts[j]) k = j;
          if (k !== cur) { cur = k; setIdx(k); }
        } });
        starts.push(0);
        items.forEach(function (it, i) {
          var d = it.querySelector('[data-ka-show-d]');
          var line = it.querySelector('[data-ka-show-line]');
          if (i > 0) {
            starts.push(st.duration() + .18);
            st.to(items[i - 1], { autoAlpha: 0, scale: .96, duration: .35, ease: 'power2.inOut' })
              .fromTo(it, { autoAlpha: 0, scale: 1.05 }, { autoAlpha: 1, scale: 1, duration: .35, ease: 'power2.inOut' }, '<')
              .to(wD, { yPercent: 140, duration: .2 }, '<')
              .to(wA, { yPercent: 0, duration: .2 }, '<');
          }
          st.fromTo(d, { clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)', duration: 1 })
            .fromTo(line, { x: 0, autoAlpha: 1 }, { x: stw, duration: 1 }, '<')
            .to(wA, { yPercent: -140, duration: .22 }, '<+=.45')
            .to(wD, { yPercent: 0, duration: .22 }, '<')
            .to(line, { autoAlpha: 0, duration: .12 }, '<+=.43')
            .to({}, { duration: .35 });
        });
        gsap.set(wD, { yPercent: 140 });
        ST.create({
          trigger: show, animation: st, pin: true, scrub: .6, anticipatePin: 1, invalidateOnRefresh: true,
          start: function () { return 'top top+=' + headerH(); },
          end: function () { return '+=' + Math.round(window.innerHeight * items.length * 1.1); },
          refreshPriority: prio(show)
        });
      }
    });

    /* ---------- Comparadores antes/después ---------- */
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    q('[data-ka-cmp]').forEach(function (cmp) {
      var knob = cmp.querySelector('[data-ka-knob]');
      var state = { p: 50 };
      var apply = function () {
        var v = Math.max(0, Math.min(100, state.p));
        cmp.style.setProperty('--p', v + '%');
        if (knob) knob.setAttribute('aria-valuenow', String(Math.round(v)));
      };
      var fromEvent = function (e) {
        var r = cmp.getBoundingClientRect();
        state.p = ((e.clientX - r.left) / r.width) * 100; apply();
      };
      var dragging = false;
      if (knob) {
        knob.addEventListener('pointerdown', function (e) {
          dragging = true; cmp.classList.add('is-drag'); gsap.killTweensOf(state);
          try { knob.setPointerCapture(e.pointerId); } catch (err) {}
          e.preventDefault();
        });
        knob.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
        var stop = function () { dragging = false; cmp.classList.remove('is-drag'); };
        knob.addEventListener('pointerup', stop);
        knob.addEventListener('pointercancel', stop);
        knob.addEventListener('keydown', function (e) {
          var k = e.key, step = e.shiftKey ? 20 : 5;
          if (k === 'ArrowLeft' || k === 'ArrowDown') state.p -= step;
          else if (k === 'ArrowRight' || k === 'ArrowUp') state.p += step;
          else if (k === 'Home') state.p = 0;
          else if (k === 'End') state.p = 100;
          else return;
          e.preventDefault(); gsap.killTweensOf(state); apply();
        });
      }
      if (finePointer) {
        // En escritorio basta con mover el mouse.
        cmp.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') { gsap.killTweensOf(state); fromEvent(e); } });
      }
      cmp.addEventListener('click', function (e) { if (e.target === knob || (knob && knob.contains(e.target))) return; gsap.killTweensOf(state); gsap.to(state, { p: ((e.clientX - cmp.getBoundingClientRect().left) / cmp.getBoundingClientRect().width) * 100, duration: .6, ease: EXPO, onUpdate: apply }); });
      // Pista: la cortina se mueve sola una vez al entrar en pantalla.
      ST.create({
        trigger: cmp, start: 'top 80%', once: true,
        onEnter: function () {
          gsap.timeline({ onUpdate: apply })
            .to(state, { p: 82, duration: .9, ease: 'power2.inOut' })
            .to(state, { p: 18, duration: 1.1, ease: 'power2.inOut' })
            .to(state, { p: 50, duration: .8, ease: 'power3.out' });
        }
      });
    });

    /* ---------- Reflector que sigue al mouse en las tarjetas ---------- */
    if (finePointer) {
      q('[data-ka-spot]').forEach(function (t) {
        t.addEventListener('pointermove', function (e) {
          var r = t.getBoundingClientRect();
          t.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          t.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      });
    }

    /* ---------- Íconos que se dibujan, filas y contadores ---------- */
    ST.batch(q('.ka-tile, [data-ka-vsrow], .ka-vs__row--head'), {
      start: 'top 88%', once: true,
      onEnter: function (b) {
        b.forEach(function (el, k) {
          el.classList.add('is-drawn');
          var paths = el.querySelectorAll('.ka-ico--draw [pathLength]');
          if (paths.length) gsap.to(paths, { strokeDashoffset: 0, duration: 1.1, ease: 'power2.inOut', stagger: .12, delay: k * .1 });
        });
      }
    });
    ST.batch(q('[data-ka-vsrow]'), {
      start: 'top 92%', once: true,
      onEnter: function (b) { gsap.from(b, { x: -24, opacity: 0, duration: .9, stagger: .07, ease: P4 }); }
    });
    q('[data-ka-count]').forEach(function (el) {
      var to = Number(el.getAttribute('data-ka-count')) || 0, o = { v: 0 };
      el.textContent = '0';
      ST.create({ trigger: el, start: 'top 90%', once: true, onEnter: function () {
        gsap.to(o, { v: to, duration: 1.6, ease: 'power3.out', onUpdate: function () { el.textContent = String(Math.round(o.v)); } });
      } });
    });
    var pills = q('[data-ka-pill]');
    if (pills.length) gsap.from(pills, { opacity: 0, scale: .8, duration: .6, stagger: .035, ease: 'back.out(1.7)', scrollTrigger: { trigger: pills[0].parentNode, start: 'top 88%', once: true } });
    var qs = q('[data-ka-q]');
    if (qs.length) gsap.from(qs, { opacity: 0, x: 16, duration: .7, stagger: .04, ease: P4, scrollTrigger: { trigger: qs[0].parentNode, start: 'top 88%', once: true } });

    /* ---------- Expediente: línea de escaneo ---------- */
    var doc = root.querySelector('.ka-doc');
    var scan = root.querySelector('.ka-doc__scan');
    if (doc && scan) {
      var scanTw = gsap.fromTo(scan, { y: -100 }, { y: function () { return doc.offsetHeight; }, duration: 3.4, ease: 'power1.inOut', repeat: -1, repeatDelay: .6, paused: true });
      ST.create({ trigger: doc, start: 'top bottom', end: 'bottom top', onToggle: function (self) { self.isActive ? scanTw.play() : scanTw.pause(); } });
    }

    /* ---------- Profundidad: collage de Max y galería del consultorio ---------- */
    q('[data-ka-collage]').forEach(function (collage) {
      q('[data-ka-depth]', collage).forEach(function (el) {
        var dpt = Number(el.getAttribute('data-ka-depth')) || 0;
        gsap.fromTo(el, { y: dpt * 2.2 }, { y: -dpt * 2.2, ease: 'none', scrollTrigger: { trigger: collage, start: 'top bottom', end: 'bottom top', scrub: true } });
      });
    });
    var phs = q('[data-ka-ph]');
    if (phs.length) {
      gsap.set(phs, { clipPath: 'inset(100% 0 0 0 round 22px)' });
      ST.batch(phs, { start: 'top 90%', once: true, onEnter: function (b) {
        gsap.to(b, { clipPath: 'inset(0% 0 0 0 round 22px)', duration: 1.3, stagger: .12, ease: 'power4.inOut' });
      } });
    }

    /* ---------- Escritorio: parallax de fotos del consultorio y cursor ---------- */
    mm.add('(min-width: 990px)', function () {
      q('[data-ka-ph] img').forEach(function (img, i) {
        gsap.fromTo(img, { yPercent: -7 - i }, { yPercent: 7 + i, ease: 'none', scrollTrigger: { trigger: img.parentNode, start: 'top bottom', end: 'bottom top', scrub: true } });
      });
    });
    mm.add('(min-width: 990px) and (hover: hover) and (pointer: fine)', function () {
      var cur = root.querySelector('[data-ka-cursor-el]');
      var txt = root.querySelector('[data-ka-cursor-txt]');
      if (!cur || !txt) return;
      var cx = gsap.quickTo(cur, 'x', { duration: .45, ease: 'power3.out' });
      var cy = gsap.quickTo(cur, 'y', { duration: .45, ease: 'power3.out' });
      var move = function (e) {
        cx(e.clientX); cy(e.clientY);
        var host = e.target && e.target.closest ? e.target.closest('[data-ka-cursor]') : null;
        var onKnob = e.target && e.target.closest && e.target.closest('[data-ka-knob]');
        if (host && !onKnob) { txt.textContent = host.getAttribute('data-ka-cursor'); cur.classList.add('is-on'); }
        else cur.classList.remove('is-on');
      };
      window.addEventListener('pointermove', move, { passive: true });
      return function () { window.removeEventListener('pointermove', move); cur.classList.remove('is-on'); };
    });


    /* ---------- Escritorio ---------- */
    mm.add('(min-width: 990px)', function () {
      var list = root.querySelector('.ka-steps__list');
      var fill = root.querySelector('[data-ka-fill]');
      if (list && fill) {
        gsap.fromTo(fill, { scaleX: 0 }, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: list, start: 'top 62%', end: 'bottom 62%', scrub: .6 } });
      }

      /* 6. Resultados: scroll horizontal fijado */
      var undo = [];
      q('[data-ka-results]').forEach(function (res) {
        var track = res.querySelector('[data-ka-track]');
        var vp = res.querySelector('[data-ka-viewport]');
        if (!track || !vp) return;
        res.classList.add('is-pinned');
        var dist = function () { return Math.max(0, track.scrollWidth - vp.clientWidth); };
        if (dist() > 40) {
          gsap.to(track, {
            x: function () { return -dist(); }, ease: 'none',
            scrollTrigger: {
              trigger: res, pin: true, scrub: .8, anticipatePin: 1, invalidateOnRefresh: true,
              start: function () { return 'top top+=' + headerH(); },
              end: function () { return '+=' + dist(); },
              refreshPriority: prio(res)
            }
          });
        }
        undo.push(function () { res.classList.remove('is-pinned'); gsap.set(track, { clearProps: 'transform' }); });
      });
      return function () { undo.forEach(function (u) { u(); }); };
    });

    /* ---------- Mouse fino: tilt y botones magnéticos ---------- */
    mm.add('(min-width: 990px) and (hover: hover) and (pointer: fine)', function () {
      var offs = [];
      q('[data-ka-tilt]').forEach(function (card) {
        var rx = gsap.quickTo(card, 'rotationX', { duration: .6, ease: 'power3.out' });
        var ry = gsap.quickTo(card, 'rotationY', { duration: .6, ease: 'power3.out' });
        var move = function (e) {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
          ry(px * 6); rx(-py * 6);
        };
        var leave = function () { rx(0); ry(0); };
        card.addEventListener('pointermove', move);
        card.addEventListener('pointerleave', leave);
        offs.push(function () { card.removeEventListener('pointermove', move); card.removeEventListener('pointerleave', leave); gsap.set(card, { rotationX: 0, rotationY: 0 }); });
      });
      q('[data-ka-magnet]').forEach(function (btn) {
        var mx = gsap.quickTo(btn, 'x', { duration: .5, ease: 'power3.out' });
        var my = gsap.quickTo(btn, 'y', { duration: .5, ease: 'power3.out' });
        var move = function (e) {
          var r = btn.getBoundingClientRect();
          mx((e.clientX - (r.left + r.width / 2)) * .22);
          my((e.clientY - (r.top + r.height / 2)) * .3);
        };
        var leave = function () { gsap.to(btn, { x: 0, y: 0, duration: .9, ease: 'elastic.out(1, .45)' }); };
        btn.addEventListener('pointermove', move);
        btn.addEventListener('pointerleave', leave);
        offs.push(function () { btn.removeEventListener('pointermove', move); btn.removeEventListener('pointerleave', leave); gsap.set(btn, { x: 0, y: 0 }); });
      });
      return function () { offs.forEach(function (f) { f(); }); };
    });

    if (ST.sort) ST.sort();
    /* Recalcular cuando cargan fuentes e imágenes */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ST.refresh(); });
    window.addEventListener('load', function () { ST.refresh(); }, { once: true });
  } catch (err) {
    // Cualquier falla: se muestra todo sin animación.
    html.classList.remove('ka-js');
    root.classList.remove('is-gsap');
    if (window.console) console.warn('[kong-asesorias]', err);
  }
})();
